export const SET_CONFIG = "SET_CONFIG";
export const SET_PROPERTY = "SET_PROPERTY";
